import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function InspectionPlannerIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M15.3721 9.00293L16.8272 10.376L10.794 16.7676L7.17286 12.9312L8.62794 11.5581L10.794 13.8535L15.3721 9.00292L15.3721 9.00293ZM22 3V19C22 20.6543 20.6543 22 19 22H5C3.3457 22 2 20.6543 2 19V3H7V2H9V3H15V2H17V3H22ZM20 5H17V7H15V5H9V7H7V5H4V19C4 19.5513 4.44824 20 5 20H19C19.5518 20 20 19.5513 20 19V5Z",
    fill: "currentColor"
  }));
}